<template>
  <div class="min-h-screen flex flex-col">
    <div class="container mx-auto max-w-7xl">
      <header class="flex justify-between items-center p-4 xl:px-0">
        <router-link class="" to="/"
          ><img src="../assets/logo.png" alt="" width="200"
        /></router-link>
      </header>
    </div>
    <slot></slot>
    <footer class="py-5 text-center text-xs">
      <a href="#">Termeni si conditii</a>
      <a href="#" class="ml-12">Politica de confidentialitate</a>
      <a href="#" class="ml-12">GDPR</a>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
